/* eslint-disable @typescript-eslint/no-explicit-any */
import { API } from 'aws-amplify'
import { useState, useEffect } from 'react'

import { ErrorProps } from './common'
import { GetCategoryQuery } from '../API'
import { getCategory } from '../api/queries'
import { Category } from '../models/API'
import { jsonParse } from '../utils/ObjectUtil'

const fetchQuery = async (query: any, variables: any) => {
  return new Promise((resolve, reject) => {
    const result = API.graphql({
      query,
      variables,
      authMode: 'AWS_IAM',
    }) as Promise<{
      data: GetCategoryQuery
    }>

    result
      .then(({ data: { getCategory } }) => {
        resolve(getCategory)
      })
      .catch((err) => reject(err))
  })
}
interface Props {
  id?: string | null | undefined
}

const useCategoryDetails = ({ id }: Props) => {
  const [category, setCategory] = useState<Category>()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<ErrorProps>()

  useEffect(() => {
    let didCancel = false
    const fetchData = async () => {
      if (didCancel) return
      setLoading(true)

      try {
        const data = (await fetchQuery(getCategory, {
          id,
        })) as unknown as Category

        const mandatoryCheckDetails = jsonParse(
          jsonParse(data.mandatoryCheckDetails as string),
        )
        setCategory({
          ...data,
          ...(mandatoryCheckDetails && {
            mandatoryCheckDetails: {
              FIELD_REQ: 0,
              ...mandatoryCheckDetails,
            },
          }),
        })
      } catch (e) {
        console.log(e)
        setError({
          title: 'Fail to load category',
          message: '',
        })
      }
      setLoading(false)
    }

    if (id) fetchData()

    return () => {
      didCancel = true
    }
  }, [id])

  return {
    category,
    apiLoading: loading,
    apiError: error,
  }
}
export default useCategoryDetails
